import capture from '../../i18n/en/capture';
import desktopWeb from '../../i18n/en/desktop-web';
import learn from '../../i18n/en/learn';
import shared from '../../i18n/en/shared';

import { BaseTranslation, Namespaces } from '../../i18n/i18n-types';

type NamespaceDict = { [key in Namespaces]: BaseTranslation };

export const namespaceDictionary: NamespaceDict = {
  'desktop-web': desktopWeb,
  capture: capture,
  learn: learn,
  shared: shared,
};

export default namespaceDictionary;
